
import {
  defineComponent,
  ref,
  computed,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { formatNumber } from '@/helpers';

export default defineComponent({
  emits: ['close'],

  props: {
    buttonDisabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },

  setup(props, context) {
    const router = useRouter();
    const store = useStore();
    const isOrderPage = computed(() => store.getters['page/pageType'] === 'order');
    const root = ref<InstanceType<typeof HTMLElement>>();

    const totalPerMonth = computed(() => formatNumber(store.getters['cart/commodityPerMonth'], 2));
    const totalPerYear = computed(() => formatNumber(store.getters['cart/commodityPerYear'], 2));

    const gotoOrder = () => {
      if (!isOrderPage.value) {
        router.push('/bestellung/adresse/');
        context.emit('close');
      }
    };

    return {
      root,
      gotoOrder,
      totalPerMonth,
      totalPerYear,
      isOrderPage,
    };
  },
});
